export default "/images/logo-new.png?88eeedcb6d12f0901fdac3372170ab1a";